/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query GetDataPanelData($id: ID!, $theGeom: Geom!, $zoom: Int) {
    dataPanel(id: $id) {
      id
      data(theGeom: $theGeom, zoom: $zoom)
    }
  }
`): DocumentNode);
